var _style, _defs, _path, _g, _g2, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCamionLoader(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "e58Ebp6VhOv1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 150 150",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\r\n#e58Ebp6VhOv12_to {animation: e58Ebp6VhOv12_to__to 500ms linear infinite normal forwards}@keyframes e58Ebp6VhOv12_to__to { 0% {transform: translate(113.410683px,125.311609px)} 100% {transform: translate(1.800001px,61.767629px)}} #e58Ebp6VhOv15_ts {animation: e58Ebp6VhOv15_ts__ts 500ms linear infinite normal forwards}@keyframes e58Ebp6VhOv15_ts__ts { 0% {transform: translate(76.362389px,81.504948px) scale(1,1)} 20% {transform: translate(76.362389px,81.504948px) scale(0.98,0.98)} 40% {transform: translate(76.362389px,81.504948px) scale(1,1)} 60% {transform: translate(76.362389px,81.504948px) scale(0.98,0.98)} 80% {transform: translate(76.362389px,81.504948px) scale(1,1)} 100% {transform: translate(76.362389px,81.504948px) scale(0.98,0.98)}} #e58Ebp6VhOv16_to {animation: e58Ebp6VhOv16_to__to 500ms linear infinite normal forwards}@keyframes e58Ebp6VhOv16_to__to { 0% {transform: translate(77.949999px,73.387499px)} 20% {transform: translate(77.949999px,72.387499px)} 40% {transform: translate(77.949999px,73.387499px)} 60% {transform: translate(77.949999px,72.387499px)} 80% {transform: translate(77.949999px,73.387499px)} 100% {transform: translate(77.949999px,72.387499px)}} #e58Ebp6VhOv24_to {animation: e58Ebp6VhOv24_to__to 500ms linear infinite normal forwards}@keyframes e58Ebp6VhOv24_to__to { 0% {offset-distance: 0%} 40% {offset-distance: 34.27688%} 60% {offset-distance: 59.496432%} 100% {offset-distance: 100%}} #e58Ebp6VhOv25_to {animation: e58Ebp6VhOv25_to__to 500ms linear infinite normal forwards}@keyframes e58Ebp6VhOv25_to__to { 0% {offset-distance: 0%} 40% {offset-distance: 38.707549%} 60% {offset-distance: 58.217629%} 100% {offset-distance: 100%}} #e58Ebp6VhOv26_to {animation: e58Ebp6VhOv26_to__to 500ms linear infinite normal forwards}@keyframes e58Ebp6VhOv26_to__to { 0% {offset-distance: 0%} 40% {offset-distance: 39.957341%} 60% {offset-distance: 59.590808%} 100% {offset-distance: 100%}} #e58Ebp6VhOv27_to {animation: e58Ebp6VhOv27_to__to 500ms linear infinite normal forwards}@keyframes e58Ebp6VhOv27_to__to { 0% {offset-distance: 0%} 40% {offset-distance: 35.143178%} 60% {offset-distance: 60.486681%} 100% {offset-distance: 100%}} #e58Ebp6VhOv34_to {animation: e58Ebp6VhOv34_to__to 500ms linear infinite normal forwards}@keyframes e58Ebp6VhOv34_to__to { 0% {offset-distance: 0%} 40% {offset-distance: 37.620191%} 60% {offset-distance: 64.17797%} 100% {offset-distance: 100%}} #e58Ebp6VhOv35_to {animation: e58Ebp6VhOv35_to__to 500ms linear infinite normal forwards}@keyframes e58Ebp6VhOv35_to__to { 0% {offset-distance: 0%} 40% {offset-distance: 38.598406%} 60% {offset-distance: 56.990962%} 100% {offset-distance: 100%}} #e58Ebp6VhOv36_to {animation: e58Ebp6VhOv36_to__to 500ms linear infinite normal forwards}@keyframes e58Ebp6VhOv36_to__to { 0% {offset-distance: 0%} 40% {offset-distance: 36.065295%} 60% {offset-distance: 59.375088%} 100% {offset-distance: 100%}} #e58Ebp6VhOv37_to {animation: e58Ebp6VhOv37_to__to 500ms linear infinite normal forwards}@keyframes e58Ebp6VhOv37_to__to { 0% {offset-distance: 0%} 40% {offset-distance: 37.474227%} 60% {offset-distance: 64.107469%} 100% {offset-distance: 100%}} #e58Ebp6VhOv44_to {animation: e58Ebp6VhOv44_to__to 500ms linear infinite normal forwards}@keyframes e58Ebp6VhOv44_to__to { 0% {offset-distance: 0%} 40% {offset-distance: 38.258808%} 60% {offset-distance: 61.630574%} 100% {offset-distance: 100%}} #e58Ebp6VhOv45_to {animation: e58Ebp6VhOv45_to__to 500ms linear infinite normal forwards}@keyframes e58Ebp6VhOv45_to__to { 0% {offset-distance: 0%} 40% {offset-distance: 36.540082%} 60% {offset-distance: 58.347932%} 100% {offset-distance: 100%}} #e58Ebp6VhOv46_to {animation: e58Ebp6VhOv46_to__to 500ms linear infinite normal forwards}@keyframes e58Ebp6VhOv46_to__to { 0% {offset-distance: 0%} 40% {offset-distance: 37.909572%} 60% {offset-distance: 59.197262%} 100% {offset-distance: 100%}} #e58Ebp6VhOv47_to {animation: e58Ebp6VhOv47_to__to 500ms linear infinite normal forwards}@keyframes e58Ebp6VhOv47_to__to { 0% {offset-distance: 0%} 40% {offset-distance: 33.3547%} 60% {offset-distance: 60.366741%} 100% {offset-distance: 100%}} #e58Ebp6VhOv48_to {animation: e58Ebp6VhOv48_to__to 500ms linear infinite normal forwards}@keyframes e58Ebp6VhOv48_to__to { 0% {transform: translate(77.999998px,73.459848px)} 20% {transform: translate(77.999998px,72.459848px)} 40% {transform: translate(77.999998px,73.459848px)} 60% {transform: translate(77.999998px,72.459848px)} 80% {transform: translate(77.999998px,73.459848px)} 100% {transform: translate(77.999998px,72.459848px)}} #e58Ebp6VhOv56_to {animation: e58Ebp6VhOv56_to__to 500ms linear infinite normal forwards}@keyframes e58Ebp6VhOv56_to__to { 0% {transform: translate(68.150005px,53.883438px)} 20% {transform: translate(68.149998px,50.883438px)} 40% {transform: translate(68.150005px,53.883438px)} 60% {transform: translate(68.150005px,51.883438px)} 80% {transform: translate(68.150005px,53.883438px)} 100% {transform: translate(68.150005px,52.883438px)}} #e58Ebp6VhOv108_to {animation: e58Ebp6VhOv108_to__to 500ms linear infinite normal forwards}@keyframes e58Ebp6VhOv108_to__to { 0% {transform: translate(101.000004px,73.9125px)} 20% {transform: translate(101.000004px,72.9125px)} 40% {transform: translate(101.000004px,73.9125px)} 60% {transform: translate(101.000004px,72.9125px)} 80% {transform: translate(101.000004px,73.9125px)} 100% {transform: translate(101.000004px,72.9125px)}} #e58Ebp6VhOv156_to {animation: e58Ebp6VhOv156_to__to 500ms linear infinite normal forwards}@keyframes e58Ebp6VhOv156_to__to { 0% {transform: translate(49.099998px,67.459995px)} 20% {transform: translate(49.099998px,66.459995px)} 40% {transform: translate(49.099998px,67.459995px)} 60% {transform: translate(49.099998px,66.459995px)} 80% {transform: translate(49.099998px,67.459995px)} 100% {transform: translate(49.099998px,66.459995px)}} #e58Ebp6VhOv168_to {animation: e58Ebp6VhOv168_to__to 500ms linear infinite normal forwards}@keyframes e58Ebp6VhOv168_to__to { 0% {transform: translate(119.310957px,79.576198px)} 40% {transform: translate(110.602347px,73.698959px)} 100% {transform: translate(97.539433px,64.883101px)}} #e58Ebp6VhOv174 {animation: e58Ebp6VhOv174_c_o 500ms linear infinite normal forwards}@keyframes e58Ebp6VhOv174_c_o { 0% {opacity: 0} 60% {opacity: 0} 80% {opacity: 1} 100% {opacity: 0}} #e58Ebp6VhOv177 {animation: e58Ebp6VhOv177_c_o 500ms linear infinite normal forwards}@keyframes e58Ebp6VhOv177_c_o { 0% {opacity: 0} 40% {opacity: 0} 60% {opacity: 1} 80% {opacity: 0} 100% {opacity: 0}} #e58Ebp6VhOv180 {animation: e58Ebp6VhOv180_c_o 500ms linear infinite normal forwards}@keyframes e58Ebp6VhOv180_c_o { 0% {opacity: 0} 20% {opacity: 0} 40% {opacity: 1} 60% {opacity: 0} 100% {opacity: 0}} #e58Ebp6VhOv183 {animation: e58Ebp6VhOv183_c_o 500ms linear infinite normal forwards}@keyframes e58Ebp6VhOv183_c_o { 0% {opacity: 0} 20% {opacity: 1} 40% {opacity: 0} 100% {opacity: 0}}\r\n>")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "e58Ebp6VhOv2",
    d: "M42.2,49.9l-2-1.2c-.2-.1-.4,0-.4.2v2.6c0,.2.2.6.4.7l2,1.1c.2.1.4.1.4-.1v-2.7c0-.2-.2-.5-.4-.6Zm.6-1.1c.7.4,1.2,1.3,1.2,1.9v3.9c0,.7-.5.9-1.2.5l-3.2-1.9c-.7-.4-1.2-1.3-1.2-1.9v-3.9c0-.7.5-.9,1.2-.5l3.2,1.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "e58Ebp6VhOv3",
    d: "M63.2,66l-.3-.2c-.2-.1-.3,0-.3.1v.3c0,.2.1.4.3.5l.3.2c.2.1.3,0,.3-.1v-.3c0-.2-.1-.4-.3-.5Zm0,0c.2.1.3.4.3.5v.4c0,.2-.2.3-.3.1l-.4-.2c-.2-.1-.3-.4-.3-.5v-.4c0-.2.2-.3.3-.1l.4.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "e58Ebp6VhOv4",
    d: "M63.1,66.2l-.2-.1v.2l.2.1c.1,0,.1.1.1,0s0-.2-.1-.2Zm0-.1c.1.1.2.2.2.3s0,.1-.1.1l.1.3c0,0,0,0,0,0s0,0,0,0h-.1c0,0,0,0,0,0l-.1-.3-.2-.1v.2c0,0,0,0,0,0v0c0,0,0,0,0,0v-.6c0,0,0,0,0,0l.2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "e58Ebp6VhOv5",
    d: "M37.8,51.2c0-.2-.2-.4-.4-.6L35,49.2c-.2-.1-.4-.5-.4-.7v-2.6c0-.2.2-.3.4-.2l2.5,1.4c.2.1.4,0,.4-.1v-.7c0-.2-.2-.4-.4-.6l-3.1-1.8c-.7-.4-1.2-.2-1.2.5v3.9c0,.7.6,1.5,1.2,1.9L37.5,52c.2.1.4,0,.4-.1l-.1-.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "e58Ebp6VhOv6",
    d: "M48.6,53.6l-2-1.2c0,0,0,0,0,0s0,0-.1,0c0,0,0,0,0,0s0,0,0,0s0,0,0,0s0,0,0,0s0,0,0,0v0c0,0,0,0-.1,0v0c0,0,0,0,0,0s0,0,0,0s0,0,0,.1c0,0,0,0,0,0s0,0,0,.1c0,0,0,0,0,0s0,0,0,0v1.2l2.4,1.4c.2.1.4.1.4-.1v-.8c-.2-.3-.3-.6-.6-.7Zm.6-1.1c.7.4,1.2,1.3,1.2,1.9v2c0,.7-.5.9-1.2.5l-3-1.8v1.6c0,.2-.2.3-.4.1l-.7-.4c-.2-.1-.4-.4-.4-.6v-2.2-2.6c0-.7.5-.9,1.2-.5l3.3,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "e58Ebp6VhOv7",
    d: "M62.1,65.3c0-.2-.2-.4-.4-.6l-2.5-1.4c-.2-.1-.4-.5-.4-.7v-2.6c0-.2.2-.3.4-.2l2.5,1.4c.2.1.4,0,.4-.1v-.7c0-.2-.2-.4-.4-.6L58.6,58c-.7-.4-1.2-.2-1.2.5v3.9c0,.7.6,1.5,1.2,1.9l3.1,1.8c.2.1.4,0,.4-.1v-.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "e58Ebp6VhOv8",
    d: "M54.9,57.2l-2-1.2c0,0,0,0,0,0s0,0-.1,0c0,0,0,0,0,0s0,0,0,0s0,0,0,0s0,0,0,0s0,0,0,0v0c0,0,0,0-.1,0v0c0,0,0,0,0,0s0,0,0,0s0,0,0,.1c0,0,0,0,0,0s0,0,0,.1c0,0,0,0,0,0s0,0,0,0v.6l2.4,1.4c.2.1.4.1.4-.1v-.3c-.2-.2-.4-.4-.6-.6Zm.6-1c.7.4,1.2,1.3,1.2,1.9v1.4c0,.7-.5.9-1.2.5l-3-1.8v.2v0v.4c0,.2.2.6.4.7l3.2,1.9c.2.1.4.4.4.6v.7c0,.2-.2.3-.4.1l-3.9-2.2c-.7-.4-1.2-1.3-1.2-1.9v-3.9c0-.7.5-.9,1.2-.5l3.3,1.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "e58Ebp6VhOv9",
    d: "M118.7,86.8l-10,5.8.5-3.9c.1-.6.4-1.1.9-1.4l6.9-4c.6-.3,1.3,0,1.3.7l.4,2.8Z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "e58Ebp6VhOv57-fill",
    cx: 0,
    cy: 0,
    r: 44.618,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(69.5959 53.3768)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "e58Ebp6VhOv57-fill-0",
    offset: "0%",
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "e58Ebp6VhOv57-fill-1",
    offset: "30.32%",
    stopColor: "#fbfcfd"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "e58Ebp6VhOv57-fill-2",
    offset: "64.78%",
    stopColor: "#f0f3f6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "e58Ebp6VhOv57-fill-3",
    offset: "100%",
    stopColor: "#dee5ea"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "e58Ebp6VhOv58-fill",
    cx: 0,
    cy: 0,
    r: 25.2777,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(58.1346 58.6165)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "e58Ebp6VhOv58-fill-0",
    offset: "0%",
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "e58Ebp6VhOv58-fill-1",
    offset: "100%",
    stopColor: "#dee5ea"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e58Ebp6VhOv60-fill",
    x1: 59.3261,
    y1: 58.4152,
    x2: 53.7509,
    y2: 69.1459,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "e58Ebp6VhOv60-fill-0",
    offset: "0%",
    stopColor: "#dee5ea"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "e58Ebp6VhOv60-fill-1",
    offset: "16.41%",
    stopColor: "#d6dee4"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "e58Ebp6VhOv60-fill-2",
    offset: "42.19%",
    stopColor: "#c1ccd6"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "e58Ebp6VhOv60-fill-3",
    offset: "73.93%",
    stopColor: "#9db0bf"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "e58Ebp6VhOv60-fill-4",
    offset: "100%",
    stopColor: "#7b96aa"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e58Ebp6VhOv68-fill",
    x1: 47.7665,
    y1: 28.6625,
    x2: 85.4085,
    y2: 50.6789,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "e58Ebp6VhOv68-fill-0",
    offset: "0%",
    stopColor: "#9eb2c1"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "e58Ebp6VhOv68-fill-1",
    offset: "100%",
    stopColor: "#7b96aa"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e58Ebp6VhOv170-fill",
    x1: 103.7857,
    y1: 89.2762,
    x2: 120.32,
    y2: 67.7098,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "e58Ebp6VhOv170-fill-0",
    offset: "0%",
    stopColor: "#7b96aa"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "e58Ebp6VhOv170-fill-1",
    offset: "50%",
    stopColor: "#f1f5f8"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "e58Ebp6VhOv170-fill-2",
    offset: "98.91%",
    stopColor: "#7b96aa"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e58Ebp6VhOv171-fill",
    x1: 104.613311,
    y1: 90.506757,
    x2: 121.075444,
    y2: 68.887859,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "e58Ebp6VhOv171-fill-0",
    offset: "0%",
    stopColor: "#7b96aa"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "e58Ebp6VhOv171-fill-1",
    offset: "50%",
    stopColor: "#f1f5f8"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "e58Ebp6VhOv171-fill-2",
    offset: "98.91%",
    stopColor: "#7b96aa"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e58Ebp6VhOv175-fill",
    x1: 103.7857,
    y1: 89.2762,
    x2: 120.32,
    y2: 67.7098,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "e58Ebp6VhOv175-fill-0",
    offset: "0%",
    stopColor: "#7b96aa"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "e58Ebp6VhOv175-fill-1",
    offset: "50%",
    stopColor: "#f1f5f8"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "e58Ebp6VhOv175-fill-2",
    offset: "98.91%",
    stopColor: "#7b96aa"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e58Ebp6VhOv176-fill",
    x1: 104.613311,
    y1: 90.506757,
    x2: 121.075444,
    y2: 68.887859,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "e58Ebp6VhOv176-fill-0",
    offset: "0%",
    stopColor: "#7b96aa"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "e58Ebp6VhOv176-fill-1",
    offset: "50%",
    stopColor: "#f1f5f8"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "e58Ebp6VhOv176-fill-2",
    offset: "98.91%",
    stopColor: "#7b96aa"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e58Ebp6VhOv178-fill",
    x1: 103.7857,
    y1: 89.2762,
    x2: 120.32,
    y2: 67.7098,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "e58Ebp6VhOv178-fill-0",
    offset: "0%",
    stopColor: "#7b96aa"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "e58Ebp6VhOv178-fill-1",
    offset: "50%",
    stopColor: "#f1f5f8"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "e58Ebp6VhOv178-fill-2",
    offset: "98.91%",
    stopColor: "#7b96aa"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e58Ebp6VhOv179-fill",
    x1: 104.613311,
    y1: 90.506757,
    x2: 121.075444,
    y2: 68.887859,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "e58Ebp6VhOv179-fill-0",
    offset: "0%",
    stopColor: "#7b96aa"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "e58Ebp6VhOv179-fill-1",
    offset: "50%",
    stopColor: "#f1f5f8"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "e58Ebp6VhOv179-fill-2",
    offset: "98.91%",
    stopColor: "#7b96aa"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e58Ebp6VhOv181-fill",
    x1: 103.7857,
    y1: 89.2762,
    x2: 120.32,
    y2: 67.7098,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "e58Ebp6VhOv181-fill-0",
    offset: "0%",
    stopColor: "#7b96aa"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "e58Ebp6VhOv181-fill-1",
    offset: "50%",
    stopColor: "#f1f5f8"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "e58Ebp6VhOv181-fill-2",
    offset: "98.91%",
    stopColor: "#7b96aa"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e58Ebp6VhOv182-fill",
    x1: 104.613311,
    y1: 90.506757,
    x2: 121.075444,
    y2: 68.887859,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "e58Ebp6VhOv182-fill-0",
    offset: "0%",
    stopColor: "#7b96aa"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "e58Ebp6VhOv182-fill-1",
    offset: "50%",
    stopColor: "#f1f5f8"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "e58Ebp6VhOv182-fill-2",
    offset: "98.91%",
    stopColor: "#7b96aa"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e58Ebp6VhOv184-fill",
    x1: 103.7857,
    y1: 89.2762,
    x2: 120.32,
    y2: 67.7098,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "e58Ebp6VhOv184-fill-0",
    offset: "0%",
    stopColor: "#7b96aa"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "e58Ebp6VhOv184-fill-1",
    offset: "50%",
    stopColor: "#f1f5f8"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "e58Ebp6VhOv184-fill-2",
    offset: "98.91%",
    stopColor: "#7b96aa"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e58Ebp6VhOv185-fill",
    x1: 104.613311,
    y1: 90.506757,
    x2: 121.075444,
    y2: 68.887859,
    spreadMethod: "pad",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    id: "e58Ebp6VhOv185-fill-0",
    offset: "0%",
    stopColor: "#7b96aa"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "e58Ebp6VhOv185-fill-1",
    offset: "50%",
    stopColor: "#f1f5f8"
  }), /*#__PURE__*/React.createElement("stop", {
    id: "e58Ebp6VhOv185-fill-2",
    offset: "98.91%",
    stopColor: "#7b96aa"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M119,109.6c-24.3,14.1-63.8,14.1-88,0C6.6,95.5,6.7,72.8,31,58.7s63.8-14.1,88.1,0s24.2,36.8-.1,50.9Z",
    fill: "#939292"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#e58Ebp6VhOv13)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "e58Ebp6VhOv12_to",
    transform: "translate(113.410683,125.311609)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "77.5,106.8 80.2,105.2 110.8,122.8 108,124.3",
    transform: "translate(-94.15,-115.067629)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "e58Ebp6VhOv13",
    "mask-type": "luminance"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M119,109.6c-24.3,14.1-63.8,14.1-88,0C6.6,95.5,6.7,72.8,31,58.7s63.8-14.1,88.1,0s24.2,36.8-.1,50.9Z",
    fill: "#cdcccc"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "e58Ebp6VhOv15_ts",
    transform: "translate(76.362389,81.504948) scale(1,1)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M31.326581,67.306447q.2.32.794442.57076l64.34848,36.287582c0,0,1.402539.868157,3.136998.95075s3.263637-.860418,3.263637-.860418l19.422363-10.465447c0,0,1.049745-.515901,1.128362-1.24966.183439-.628935-1.355855-1.401653-1.355855-1.401653L55.536399,55.889867C43.028288,61.637738,35.11245,64.956344,32.03503,66.410178c-.288449.136269-.908449.576269-.708449.896269Z",
    transform: "translate(-77.362389,-80.504946)",
    opacity: 0.27,
    strokeWidth: 0.5
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "e58Ebp6VhOv16_to",
    transform: "translate(77.949999,73.387499)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.1,43.8l-20.7,12v0c-.2.1-.4.4-.4.7v.8v6v0c0,.3.1.6.4.7L100,102.9c.2.1.5.1.7,0v0l20.8-12c.5-.3.9-.7,1-1.3l1.4-4.4L53.1,43.8Z",
    transform: "translate(-77.949999,-73.387499)",
    clipRule: "evenodd",
    fill: "#1e1e1e",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.6,72.8c0,1.7-.5,3-1.4,3.7c0,0,0,0,0,0l-.7.5-2.6,1.6c.5-.3.9-.8,1.2-1.4.3-.7.5-1.6.5-2.6c0-.3,0-.7-.1-1-.4-3.6-2.9-7.8-5.9-9.7-.1-.1-.2-.1-.3-.2-1-.6-1.9-.8-2.7-.9-.6,0-1.1.1-1.5.3l2.5-1.5c1.2-.9,2.9-.9,4.8.2c3.4,2.1,6.2,7,6.2,11Z",
    clipRule: "evenodd",
    fill: "#31131c",
    fillRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6,74.6c0,1-.2,1.9-.5,2.6-.3.6-.7,1-1.2,1.4c0,0-.1,0-.1.1c0,0,0,0-.1,0-1.1.6-2.7.5-4.4-.5-3.5-2-6.3-6.9-6.3-10.9c0-2.1.8-3.6,2.1-4.2.5-.2,1-.3,1.5-.3.8,0,1.7.3,2.7.9.1.1.2.1.3.2c3,1.9,5.5,6,5.9,9.7c0,.4.1.7.1,1Z",
    clipRule: "evenodd",
    fill: "#4b2831",
    fillRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2,75.1c-2-1.1-3.6-3.9-3.6-6.2s1.6-3.2,3.6-2.1s3.6,3.9,3.6,6.2-1.6,3.3-3.6,2.1Z",
    clipRule: "evenodd",
    fill: "#dee2ea",
    fillRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2,72.7c-.8-.5-1.5-1.6-1.5-2.5s.7-1.3,1.5-.8s1.5,1.6,1.5,2.5-.7,1.2-1.5.8Z",
    transform: "translate(-.02 0)",
    clipRule: "evenodd",
    fill: "#31131c",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "e58Ebp6VhOv24_to",
    style: {
      offsetPath: "path('M41.400002,68.098748C42.501546,67.049897,45.079058,69.119105,45.684533,71.553291C46.31126,73.636156,45.018624,74.782814,43.374027,74.132982C40.700602,72.164025,39.597757,69.110282,41.310274,68.053883')",
      offsetRotate: "0deg"
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4,69c-.3-.2-.6-.6-.6-1s.3-.5.6-.3.6.6.6,1c0,.3-.2.4-.6.3Z",
    transform: "translate(-41.400002,-68.318748)",
    clipRule: "evenodd",
    fill: "#31131c",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "e58Ebp6VhOv25_to",
    style: {
      offsetPath: "path('M44.900002,69.898748C46.482791,72.843119,46.152199,75.393783,42.858681,73.801934C42.088218,73.246423,41.012301,71.884628,40.839792,70.930625C39.639667,67.803208,42.196927,66.412418,44.922434,69.898749')",
      offsetRotate: "0deg"
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1,70.8c-.3-.2-.6-.6-.6-1s.3-.5.6-.3.6.6.6,1-.2.5-.6.3Z",
    transform: "translate(-45.099998,-70.150002)",
    clipRule: "evenodd",
    fill: "#31131c",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "e58Ebp6VhOv26_to",
    style: {
      offsetPath: "path('M44.879999,73.929998C42.623136,74.712295,40.731803,72.187308,40.50574,69.466011C40.569105,68.067943,41.780477,67.330959,42.973271,68.075221C44.776618,69.10427,47.15442,72.581245,44.924863,73.952431')",
      offsetRotate: "0deg"
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8,74.5c-.3-.2-.6-.6-.6-1s.3-.5.6-.3.6.6.6,1-.3.5-.6.3Z",
    transform: "translate(-44.799999,-73.849998)",
    clipRule: "evenodd",
    fill: "#31131c",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "e58Ebp6VhOv27_to",
    style: {
      offsetPath: "path('M41.400002,72.018749C39.931285,69.64264,40.335062,66.793764,43.104842,68.115564C44.222027,68.832031,45.736055,70.458498,45.751829,71.749564C46.346865,75.295529,42.892322,74.802023,41.37757,72.041181')",
      offsetRotate: "0deg"
    }
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4,72.7c-.3-.2-.6-.6-.6-1s.3-.5.6-.3.6.6.6,1c0,.3-.2.4-.6.3Z",
    transform: "translate(-41.400002,-72.018749)",
    clipRule: "evenodd",
    fill: "#31131c",
    fillRule: "evenodd"
  })))), /*#__PURE__*/React.createElement("g", null, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M69,82.4c0,1.7-.5,3-1.4,3.7c0,0,0,0,0,0l-.8.5-2.6,1.6c.5-.3.9-.8,1.2-1.4.3-.7.5-1.6.5-2.6c0-.3,0-.7-.1-1-.4-3.6-2.9-7.8-5.9-9.7-.1-.1-.2-.1-.3-.2-1-.6-1.9-.8-2.7-.9-.6,0-1.1.1-1.5.3l2.5-1.5c1.2-.9,2.9-.9,4.8.2c3.5,2.1,6.3,7,6.3,11Z",
    clipRule: "evenodd",
    fill: "#31131c",
    fillRule: "evenodd"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M65.9,84.2c0,1-.2,1.9-.5,2.6-.3.6-.7,1-1.2,1.4c0,0-.1,0-.1.1c0,0,0,0-.1,0-1.1.6-2.7.5-4.4-.5-3.5-2-6.3-6.9-6.3-10.9c0-2.1.8-3.6,2.1-4.2.5-.2,1-.3,1.5-.3.8,0,1.7.3,2.7.9.1.1.2.1.3.2c3,1.9,5.5,6,5.9,9.7.1.3.1.7.1,1Z",
    clipRule: "evenodd",
    fill: "#4b2831",
    fillRule: "evenodd"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M59.6,84.7c-2-1.1-3.6-3.9-3.6-6.2s1.6-3.2,3.6-2.1s3.6,3.9,3.6,6.2-1.6,3.3-3.6,2.1Z",
    clipRule: "evenodd",
    fill: "#dee2ea",
    fillRule: "evenodd"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M59.6,82.2c-.8-.5-1.5-1.6-1.5-2.5s.7-1.3,1.5-.8s1.5,1.6,1.5,2.5-.7,1.3-1.5.8Z",
    clipRule: "evenodd",
    fill: "#31131c",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "e58Ebp6VhOv34_to",
    style: {
      offsetPath: "path('M57.799999,77.849998C59.061291,76.905312,61.258286,78.057629,62.162436,81.542951C62.481166,83.565247,61.029807,84.417237,59.246946,83.227456C56.585185,80.751402,56.722628,78.547196,57.799999,77.828401')",
      offsetRotate: "0deg"
    }
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M57.8,78.5c-.3-.2-.6-.6-.6-1s.3-.5.6-.3.6.6.6,1-.3.5-.6.3Z",
    transform: "translate(-57.799999,-77.849998)",
    clipRule: "evenodd",
    fill: "#31131c",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "e58Ebp6VhOv35_to",
    style: {
      offsetPath: "path('M61.5,79.740253C63.232535,82.937941,61.440049,85.011178,59.038031,82.979686C58.461955,82.506875,57.449515,81.031237,57.142401,80.303202C56.278553,77.214942,58.740522,75.983958,61.5,79.718656')",
      offsetRotate: "0deg"
    }
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M61.5,80.4c-.3-.2-.6-.6-.6-1s.3-.5.6-.3.6.6.6,1c0,.3-.3.5-.6.3Z",
    transform: "translate(-61.5,-79.740253)",
    clipRule: "evenodd",
    fill: "#31131c",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "e58Ebp6VhOv36_to",
    style: {
      offsetPath: "path('M61.200001,83.44025C59.347424,84.497283,57.531133,81.728552,56.988738,79.682508C56.778884,77.912131,57.988535,76.843511,59.450707,77.609271C61.180895,78.640293,63.6015,82.243109,61.221597,83.440251')",
      offsetRotate: "0deg"
    }
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2,84.1c-.3-.2-.6-.6-.6-1s.3-.5.6-.3.6.6.6,1c0,.3-.3.5-.6.3Z",
    transform: "translate(-61.200001,-83.44025)",
    clipRule: "evenodd",
    fill: "#31131c",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "e58Ebp6VhOv37_to",
    style: {
      offsetPath: "path('M57.799999,81.549999C56.084187,78.294753,57.595922,76.264709,59.894833,77.965026C60.802688,78.524856,62.09079,80.389325,62.174321,82.009303C62.044743,85.05437,59.172446,83.801789,57.8,81.571595')",
      offsetRotate: "0deg"
    }
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M57.8,82.2c-.3-.2-.6-.6-.6-1s.3-.5.6-.3.6.6.6,1-.3.5-.6.3Z",
    transform: "translate(-57.799999,-81.549999)",
    clipRule: "evenodd",
    fill: "#31131c",
    fillRule: "evenodd"
  })))), /*#__PURE__*/React.createElement("g", null, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M94.8,97.1c0,1.7-.5,3-1.4,3.7c0,0,0,0,0,0l-.8.5L90,103c.5-.3.9-.8,1.2-1.4.3-.7.5-1.6.5-2.6c0-.3,0-.7-.1-1-.4-3.6-2.9-7.8-5.9-9.7-.1-.1-.2-.1-.3-.2-1-.6-1.9-.8-2.7-.9-.6,0-1.1.1-1.5.3L83.7,86c1.2-.9,2.9-.9,4.8.2c3.5,2.1,6.3,7,6.3,10.9Z",
    clipRule: "evenodd",
    fill: "#31131c",
    fillRule: "evenodd"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M91.7,99c0,1-.2,1.9-.5,2.6-.3.6-.7,1-1.2,1.4c0,0-.1,0-.1.1c0,0,0,0-.1,0-1.1.6-2.7.5-4.4-.5-3.5-2-6.3-6.9-6.3-10.9c0-2.1.8-3.6,2.1-4.2.5-.2,1-.3,1.5-.3.8,0,1.7.3,2.7.9.1.1.2.1.3.2c3,1.9,5.5,6,5.9,9.7.1.3.1.7.1,1Z",
    clipRule: "evenodd",
    fill: "#4b2831",
    fillRule: "evenodd"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M85.4,99.5c-2-1.1-3.6-3.9-3.6-6.2s1.6-3.2,3.6-2.1s3.6,3.9,3.6,6.2-1.6,3.2-3.6,2.1Z",
    clipRule: "evenodd",
    fill: "#dee2ea",
    fillRule: "evenodd"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M85.4,97c-.8-.5-1.5-1.6-1.5-2.5s.7-1.3,1.5-.8s1.5,1.6,1.5,2.5-.7,1.3-1.5.8Z",
    clipRule: "evenodd",
    fill: "#31131c",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "e58Ebp6VhOv44_to",
    style: {
      offsetPath: "path('M83.599998,92.650002C86.12523,91.70839,87.485809,94.493676,88.019166,96.562052C88.229229,98.183579,86.929818,99.106923,85.338687,98.300741C83.107575,96.207715,81.954144,93.286193,83.599998,92.650002')",
      offsetRotate: "0deg"
    }
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M83.6,93.3c-.3-.2-.6-.6-.6-1s.3-.5.6-.3.6.6.6,1-.3.5-.6.3Z",
    transform: "translate(-83.599998,-92.650002)",
    clipRule: "evenodd",
    fill: "#31131c",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "e58Ebp6VhOv45_to",
    style: {
      offsetPath: "path('M87.300003,94.540249C88.811044,97.724104,87.096503,99.704278,85.030048,97.96933C84.150488,97.316305,82.954655,95.76051,82.894671,94.802141C82.484148,91.469654,85.019736,91.131575,87.324152,94.54025')",
      offsetRotate: "0deg"
    }
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M87.3,95.2c-.3-.2-.6-.6-.6-1s.3-.5.6-.3.6.6.6,1c0,.3-.3.5-.6.3Z",
    transform: "translate(-87.300003,-94.540249)",
    clipRule: "evenodd",
    fill: "#31131c",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "e58Ebp6VhOv46_to",
    style: {
      offsetPath: "path('M87,98.240253C85.373256,98.855313,83.211315,96.933127,82.77402,94.086718C82.691047,92.665534,83.840525,91.697752,85.237163,92.372177C87.486192,93.993005,89.053239,96.905312,87.000001,98.216104')",
      offsetRotate: "0deg"
    }
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M87,98.9c-.3-.2-.6-.6-.6-1s.3-.5.6-.3.6.6.6,1c0,.3-.3.5-.6.3Z",
    transform: "translate(-87,-98.240253)",
    clipRule: "evenodd",
    fill: "#31131c",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "e58Ebp6VhOv47_to",
    style: {
      offsetPath: "path('M83.599998,96.349998C82.146069,93.787906,82.763577,91.648856,85.073054,92.293057C86.177348,92.930673,87.748487,94.538089,87.898424,96.036068C88.472965,99.269606,85.674096,99.307361,83.57585,96.398295')",
      offsetRotate: "0deg"
    }
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M83.6,97c-.3-.2-.6-.6-.6-1s.3-.5.6-.3.6.6.6,1-.3.5-.6.3Z",
    transform: "translate(-83.599998,-96.349998)",
    clipRule: "evenodd",
    fill: "#31131c",
    fillRule: "evenodd"
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "e58Ebp6VhOv48_to",
    transform: "translate(77.999998,73.459848)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-77.999998,-73.459848)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.1,43.8l-20.7,12v0c-.2.1-.4.4-.4.7v6.9c0,.3.2.6.4.7L35,65.6c.3-4.7,3.9-6.5,8.2-4s7.9,8.4,8.2,13.4v0c.3-4.7,3.9-6.5,8.2-4s7.8,8.4,8.2,13.4L77.4,90c.2-2.9,1.6-4.6,3.6-5c.2,0,.3-.1.5-.1c0,0,0,0,0,0c.1,0,.3,0,.4,0c0,0,.1,0,.1,0c.2,0,.3,0,.5,0c0,0,.1,0,.1,0c.1,0,.3,0,.4.1c0,0,.1,0,.1,0c.1,0,.3.1.4.1s.1,0,.2.1c.2,0,.3.1.5.2.1,0,.1.1.2.1s.2.1.3.1.1.1.2.1c.2.1.4.2.6.3s.4.2.6.4c.1,0,.1.1.2.1.2.1.3.2.5.3.1,0,.1.1.2.1.1.1.3.2.4.3.1,0,.1.1.2.1.2.1.3.3.5.5c0,0,.1.1.1.1.2.2.3.3.5.5c0,0,.1.1.1.1.2.2.3.4.5.6c0,0,0,0,0,0c.2.2.3.4.5.6c0,0,0,.1.1.1.2.2.3.4.5.7c1.9,2.7,3.2,5.9,3.3,8.8l6.3,3.6c.5.3,1,0,1.2-.5l1.2-4.8v0L124,85.4L53.1,43.8Z",
    clipRule: "evenodd",
    fill: "#497dbf",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.6,91l-20.8,12l1.6-5.4.4-.1L124,85.4l-1.4,4.4c-.2.5-.5,1-1,1.2Z",
    clipRule: "evenodd",
    fill: "#223b7c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.4,97.3L90.8,91.2c1.7,2.5,2.8,5.5,2.9,8.2L100,103c.4.3,1,0,1.1-.5l1.2-5-.9-.2Z",
    clipRule: "evenodd",
    fill: "#2353a1",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.8,76.2c1.7,2.5,2.8,5.5,3,8.3l9.6,5.6c.2-2.5,1.3-4.2,2.9-4.9l-15.5-9Z",
    clipRule: "evenodd",
    fill: "#2353a1",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M35.1,65.6c.2-2.5,1.3-4.2,2.9-4.9l-6-3.4v6.1c0,.3.1.6.4.7",
    clipRule: "evenodd",
    fill: "#2353a1",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.5,66.7c1.7,2.6,2.8,5.5,3,8.3v0c.2-2.5,1.3-4.2,3-4.8l-6-3.5Z",
    clipRule: "evenodd",
    fill: "#2353a1",
    fillRule: "evenodd"
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "e58Ebp6VhOv56_to",
    transform: "translate(68.150005,53.883438)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.05,1.05) translate(-68.149998,-53.883438)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99.8,49.3L63.6,28.5c-6.4-3.6-10.9-3.4-15-1.1s-14.9,8.5-14.9,8.5s15.8,10.6,18.4,12.1L83,81c0,0,19.2-9.7,19.5-9.9c1.6-1,2.8-3.7,2.8-7.7.1-5.9-2.9-12.5-5.5-14.1Z",
    clipRule: "evenodd",
    fill: "url(#e58Ebp6VhOv57-fill)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.9,61.1L36.4,36c-2.6-1.5-5.6,1.7-5.6,7.7s1.8,12.1,4.5,13.6L76.7,81.1c2.6,1.5,8.8.3,8.8-5.7c0-6.1-3-12.8-5.6-14.3Z",
    clipRule: "evenodd",
    fill: "url(#e58Ebp6VhOv58-fill)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M85.5,75.6L30.8,44c.1,6,1.9,11.8,4.5,13.3L77.1,81.5c2.6,1.5,8.3,0,8.4-5.9Z",
    clipRule: "evenodd",
    fill: "url(#e58Ebp6VhOv60-fill)",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M99.8,49.3l-3.1-1.8-1.8.3L77,57.7l-7.6,8.5L83.2,80.9c0,0,19.2-9.7,19.5-9.9c1.6-1,2.8-3.7,2.8-7.7-.1-5.8-3.1-12.4-5.7-14Z",
    clipRule: "evenodd",
    fill: "#3e73b9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.9,61.1L76,58.9l-6.8,7.6-4.9,6-.2,1.4l12.5,7.2c2.6,1.5,8.8.3,8.8-5.7.1-6.1-2.9-12.8-5.5-14.3Z",
    clipRule: "evenodd",
    fill: "#0e69b0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.2,66.4l-4.9,6-.2,1.5l13,7.5c2.6,1.5,8.3,0,8.4-5.8L69.4,66.3l-.2.1Z",
    clipRule: "evenodd",
    fill: "#153a61",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M79,58.2L97.1,47.8l-2-1.2L76.9,57c-1.3.7-2.4,1.7-3.3,2.8L62.6,73l2.2,1.2L75.6,61c.9-1.1,2.1-2.1,3.4-2.8Z",
    clipRule: "evenodd",
    fill: "#9eb2c1",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M87.3,56.7L42.4,31c0,0,7.1-4.2,7.7-4.3L94.9,52.4l-7.6,4.3Z",
    clipRule: "evenodd",
    fill: "#676767",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M43.8,30.2l43.6,25l6.2-3.6L50.1,26.7c-.4,0-4.3,2.3-6.3,3.5Z",
    clipRule: "evenodd",
    fill: "url(#e58Ebp6VhOv68-fill)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M66.1,36.5c0,0,0,.6,0,1.1s-.3,1-1,1.4c-1.3.8-3.5.8-4.8,0-.7-.4-1-.9-1-1.4s0-1.1,0-1.1h6.8Z",
    clipRule: "evenodd",
    fill: "#7b96aa",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.1,35.1c1.3.8,1.3,2,0,2.8s-3.5.8-4.8,0-1.3-2,0-2.8c1.3-.7,3.4-.7,4.8,0Z",
    clipRule: "evenodd",
    fill: "#bccad3",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e58Ebp6VhOv76)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "38.1,45.9 44.2,49.4 44.3,56.2 38.2,52.6",
    fill: "#e52628"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "e58Ebp6VhOv76"
  }, /*#__PURE__*/React.createElement("use", {
    width: 5.600002,
    height: 8.607742,
    xlinkHref: "#e58Ebp6VhOv2"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e58Ebp6VhOv81)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "62.3,65.2 63.8,66.1 63.8,67.5 62.3,66.7",
    fill: "#e52628"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "e58Ebp6VhOv81"
  }, /*#__PURE__*/React.createElement("use", {
    width: 1,
    height: 1.41803,
    xlinkHref: "#e58Ebp6VhOv3"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e58Ebp6VhOv86)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "62.6,65.6 63.5,66.1 63.5,67.2 62.7,66.7",
    fill: "#e52628"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "e58Ebp6VhOv86"
  }, /*#__PURE__*/React.createElement("use", {
    width: 0.400002,
    height: 0.800003,
    xlinkHref: "#e58Ebp6VhOv4"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e58Ebp6VhOv91)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "32.9,42.8 38,45.8 38,52.6 32.9,49.6",
    fill: "#e52628"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "e58Ebp6VhOv91"
  }, /*#__PURE__*/React.createElement("use", {
    width: 4.700001,
    height: 8.345291,
    xlinkHref: "#e58Ebp6VhOv5"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e58Ebp6VhOv96)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "44.6,49.6 50.7,53.2 50.7,59.9 44.6,56.4",
    fill: "#e52628"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "e58Ebp6VhOv96"
  }, /*#__PURE__*/React.createElement("use", {
    width: 5.700005,
    height: 6.807739,
    xlinkHref: "#e58Ebp6VhOv6"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e58Ebp6VhOv101)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "57.1,56.9 62.3,59.9 62.3,66.6 57.1,63.7",
    fill: "#e52628"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "e58Ebp6VhOv101"
  }, /*#__PURE__*/React.createElement("use", {
    width: 4.700001,
    height: 8.345295,
    xlinkHref: "#e58Ebp6VhOv7"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e58Ebp6VhOv106)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "50.8,53.3 56.9,56.8 57,63.6 50.9,60",
    fill: "#e52628"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "e58Ebp6VhOv106"
  }, /*#__PURE__*/React.createElement("use", {
    width: 5.700001,
    height: 8.812889,
    xlinkHref: "#e58Ebp6VhOv8"
  })))))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "e58Ebp6VhOv108_to",
    transform: "translate(101.000004,73.9125)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-101.000004,-73.9125)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M124.4,83.5L102.8,96v-10.1c0-.4-.1-.8-.2-1.1L95.5,69.3L82.7,62l20-11.5c.8-.5,1.8-.5,2.7,0l11,5.8c.7.4,1.2.9,1.5,1.6l6.4,14.3c.2.5.3,1,.3,1.5v9.8Z",
    clipRule: "evenodd",
    fill: "#f1f5f8",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "124,85.4 102.9,97.5 102.4,97.7 102.9,95.9 124.4,83.4",
    clipRule: "evenodd",
    fill: "#9eb2c1",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.6,84.7L96.2,69.9c-.3-.7-.8-1.3-1.5-1.6L83.4,61.8c-.5-.3-1.2.1-1.2.7v21.5l20.1,11.6c.3.2.5.5.4.9l-.3,1.1v0l.4-1.6c0-.1,0-.1,0-.2v-10c.1-.4,0-.7-.2-1.1Z",
    fill: "#bccad3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.4,71.6l4.8,11.1c.1.2-.1.4-.3.3L91,78.4c-.1-.1-.1-.1-.1-.3v-8.3c0-.2.2-.4.4-.3L94,71c.1.2.3.4.4.6Zm-5.5-3.1v8.3c0,.2-.2.4-.4.3L84.8,75c-.1-.1-.1-.1-.1-.3v-8.3c0-.2.2-.4.4-.3l3.7,2.1c0,.1.1.2.1.3Z",
    clipRule: "evenodd",
    fill: "#4a9fd7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M101.1,85.1c0-.2,0-.4-.1-.5L95,70.9c-.1-.3-.3-.5-.6-.7l-4.3-2.4c-.1-.1-.2-.1-.3,0s-.2.2-.2.3v14.7c0,.2.2.4,1.1,1.5s2.4,2.9,3.7,4.9v0L101,93v-7.9ZM91.1,84c-.5-.6-1-1.2-1-1.3v-14.7l4.2,2.4c.2.1.4.3.4.5l6,13.7c.1.1.1.3.1.4v7.2l-6-3.5c-1.4-1.9-2.8-3.6-3.7-4.7Z",
    fill: "#7b96aa"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M122.3,72L104,82.6c-.4.3-1,.1-1.2-.4L98.1,71.6c-.2-.4,0-.8.3-1L116.7,60c.4-.3,1-.1,1.2.4L122.6,71c.2.4.1.8-.3,1Z",
    clipRule: "evenodd",
    fill: "#4a9fd7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    width: 10,
    height: 9.41584,
    xlinkHref: "#e58Ebp6VhOv9",
    clipRule: "evenodd",
    fill: "#31131c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e58Ebp6VhOv127)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 13.2,
    height: 0.4,
    rx: 0,
    ry: 0,
    transform: "matrix(.865-.5018 0.5018 0.865 107.978783 91.838838)",
    fill: "#4b2831"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 13.2,
    height: 0.4,
    rx: 0,
    ry: 0,
    transform: "matrix(.865-.5018 0.5018 0.865 107.500964 90.898238)",
    fill: "#4b2831"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 13.2,
    height: 0.4,
    rx: 0,
    ry: 0,
    transform: "matrix(.865-.5018 0.5018 0.865 107.174904 89.728778)",
    fill: "#4b2831"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "e58Ebp6VhOv127"
  }, /*#__PURE__*/React.createElement("use", {
    width: 10,
    height: 9.41584,
    xlinkHref: "#e58Ebp6VhOv9"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M102.3,95.6L85.7,86c.2.1.3.2.5.3.1,0,.1.1.2.1.2.1.3.2.5.3.1,0,.1.1.2.1.1.1.3.2.4.3.1,0,.1.1.2.1.2.1.3.3.5.5c0,0,.1.1.1.1.2.2.3.3.5.5c0,0,.1.1.1.1.2.2.3.4.5.6c0,0,0,0,0,0c.2.2.3.4.5.6c0,0,0,.1.1.1.2.2.3.4.5.7.1.2.3.4.4.6l10.6,6.1l1,.3.3-1.1c0-.2-.2-.5-.5-.7Z",
    fill: "#497dbf"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.5,84.9c0,0,.1,0,.1,0c.1,0,.3,0,.4.1c0,0,.1,0,.1,0c.1,0,.3.1.4.1s.1,0,.2.1c.2,0,.3.1.5.2.1,0,.1.1.2.1s.2.1.3.1.1.1.2.1c.2.1.3.2.5.3l-3.1-2v.8c.1.1.2.1.2.1Z",
    fill: "#497dbf"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M102.4,97.5c-.1,0-.3,0-.4-.1l-.4-.3v-4.5l.7.4c.2.1.4.1.5.1s.4,0,.5-.1l3.5-2v2.4l-.5,1.8-3.7,2.1c0,.2-.1.2-.2.2v0Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.7,91.3v2.2l-.4,1.8-3.6,2.1c-.1,0-.2.1-.3.1s-.2,0-.3-.1l-.4-.2v-4.2l.5.3c.2.1.4.2.6.2s.4-.1.6-.2l3.3-2m.3-.5l-3.7,2.1c-.1.1-.3.1-.5.1s-.3,0-.5-.1l-1-.6v4.9l.5.3c.1.1.3.1.4.1.2,0,.3,0,.4-.1l3.7-2.1.5-1.9v0-2.7h.2Z",
    fill: "#7b96aa"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "120.4,85.9 120.4,83.2 124.3,81 124.3,83.4 123.8,85.3 120,87.5",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.1,81.3v2.2l-.4,1.8-3.4,2l.3-1.2v0v0-2.5l3.5-2.3m.3-.6l-4.2,2.4v2.7l-.5,1.9l4.2-2.4.5-1.9v-2.7v0Z",
    fill: "#7b96aa"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 0.7,
    height: 4.8,
    rx: 0,
    ry: 0,
    transform: "matrix(.9901-.1402 0.1402 0.9901 97.260257 69.563829)",
    fill: "#497dbf"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M98.1,69.3c0,.3-.2.7-.5.9s-.5,0-.5-.3.2-.7.5-.9.5,0,.5.3Z",
    clipRule: "evenodd",
    fill: "#497dbf",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M99.5,79.4l-2.2.1c-.4,0-.8-.3-.8-.8l-.2-4.1c0-.4.3-.8.8-.8l2.2-.1c.4,0,.8.3.8.8l.2,4.1c-.1.4-.4.8-.8.8Z",
    clipRule: "evenodd",
    fill: "#fbb814",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 0.7,
    height: 5,
    rx: 0,
    ry: 0,
    transform: "matrix(.5725-.8199 0.8199 0.5725 116.911935 58.903639)",
    fill: "#497dbf"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M116.7,58.2c0,.3.2.7.5.9s.5,0,.5-.3-.2-.7-.5-.9-.5-.1-.5.3Z",
    clipRule: "evenodd",
    fill: "#497dbf",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "82.2,85.1 77.7,87.7 77.7,87 82.2,83.7",
    clipRule: "evenodd",
    fill: "#223b7c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.034127,86.195899C85.934127,86.695899,86.9,87.7,87.8,88.5L91,86.6c-1-1.1-2.1-2-3.3-2.6-2.1-1.2-4-1.4-5.4-.6c0,0-.1.1-.1.1s-2.9,1.8-2.9,1.8l.473173.126609c1.1-.8,3.160954-.33071,5.260954.76929Z",
    clipRule: "evenodd",
    fill: "#96d1f4",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "88.1,88.3 88.1,88.9 90.9,87.3 90.9,86.6",
    transform: "translate(-.1-.04)",
    clipRule: "evenodd",
    fill: "#2353a1",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.8,85.7c-3.4-2-6.4-1.1-7.4,1.8l.3.2c1.1-2.5,3.8-3.2,7-1.4.9.5,2.5,1.7,3.3,2.6v-.7c-.9-1.1-2-1.8-3.2-2.5Z",
    clipRule: "evenodd",
    fill: "#497dbf",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M121.6,66.3l.1-.1c.4-.2.5-.4.6-.9l.1-3.9c0-.5-.3-1-.6-.8l-.4.3c-.3.2-.5.4-.6.9l-.1,2.6.9,1.9Z",
    clipRule: "evenodd",
    fill: "#fbb814",
    fillRule: "evenodd"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "e58Ebp6VhOv156_to",
    transform: "translate(49.099998,67.459995)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-49.099998,-67.459995)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "38.9,61.9 34.4,64.5 34.4,63.7 38.784933,60.394574",
    clipRule: "evenodd",
    fill: "#223b7c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.410219,62.916856c.9.5,2.4,1.54,3.3,2.34l2.84-1.68C46.550219,62.476856,45.5,61.4,44.3,60.8c-2.1-1.2-4-1.4-5.4-.6c0,0-.1.1-.1.1s-2.9,1.8-2.9,1.8l.230219.296856c1.1-.8,3.28-.68,5.28.52Z",
    transform: "translate(-.045286-.202282)",
    clipRule: "evenodd",
    fill: "#96d1f4",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "44.7,65 44.7,65.7 47.5,64.1 47.5,63.4",
    transform: "translate(0-.025285)",
    clipRule: "evenodd",
    fill: "#2353a1",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5,62.4c-3.4-2-6.4-1.1-7.4,1.8l.3.2c1.1-2.5,3.8-3.2,7-1.4.9.5,2.5,1.7,3.3,2.6v-.6c-1-1.1-2.1-1.9-3.2-2.6Z",
    clipRule: "evenodd",
    fill: "#497dbf",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-.04-.02)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "55.3,71.4 50.8,74 50.8,73.2 55.3,70",
    transform: "translate(0-.08)",
    clipRule: "evenodd",
    fill: "#223b7c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.072129,72.439246c.9.5,2.06,1.38,2.96,2.18L64.1,72.9c-1-1.1-2.1-2-3.3-2.6-2.1-1.2-4-1.4-5.4-.6c0,0-.1.1-.1.1s-2.9,1.8-2.9,1.8l.412129.259246c1.1-.8,3.16-.62,5.26.58Z",
    transform: "translate(-.14-.08)",
    clipRule: "evenodd",
    fill: "#96d1f4",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "61.2,74.5 61.2,75.2 64,73.5 64,72.9",
    transform: "translate(-.1-.06)",
    clipRule: "evenodd",
    fill: "#2353a1",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.9,71.9c-3.4-2-6.4-1.1-7.4,1.8l.3.2c1.1-2.5,3.8-3.2,7-1.4.9.5,2.5,1.7,3.3,2.6v-.7c-.9-1-2-1.8-3.2-2.5Z",
    clipRule: "evenodd",
    fill: "#497dbf",
    fillRule: "evenodd"
  }))))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    display: "none",
    transform: "translate(0-1)",
    mask: "url(#e58Ebp6VhOv172)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "e58Ebp6VhOv168_to",
    transform: "translate(119.310957,79.576198)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.682233,1.520784) translate(-115.449997,-74.749998)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "102.9,91.9 128.8,57.7 127.6,56.8 101.7,90.9",
    fill: "url(#e58Ebp6VhOv170-fill)"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "103.2,92.7 129.2,58.6 128.8,58.3 102.9,92.4",
    fill: "url(#e58Ebp6VhOv171-fill)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "e58Ebp6VhOv172",
    "mask-type": "luminance"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M122.3,72L104,82.6c-.4.3-1,.1-1.2-.4L98.1,71.6c-.2-.4,0-.8.3-1L116.7,60c.4-.3,1-.1,1.2.4L122.6,71c.2.4.1.8-.3,1Z",
    clipRule: "evenodd",
    fill: "#4a9fd7",
    fillRule: "evenodd"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "e58Ebp6VhOv174",
    opacity: 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98.80345,73.18651l3.8247-5.03561l3.41056-1.97552-6.52415,8.6149-.71111-1.60377Z",
    fill: "url(#e58Ebp6VhOv175-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.66571,75.13118l7.13936-9.39969l1.06882-.6191-7.99888,10.49084-.2093-.47205Z",
    fill: "url(#e58Ebp6VhOv176-fill)"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "e58Ebp6VhOv177",
    transform: "translate(.000001-.999999)",
    opacity: 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "M116.7,60c.20372-.15279.45933-.17589.68754-.09571L101.95168,80.28677l-.71516-1.61292l13.17778-17.3499L116.7,60Z",
    transform: "translate(0 0.000001)",
    fill: "url(#e58Ebp6VhOv178-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.9,60.4l.06228.14047-15.65953,20.53808-.20397-.46002l15.59185-20.52827c.08782.08341.16053.18763.20937.30974Z",
    fill: "url(#e58Ebp6VhOv179-fill)"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "e58Ebp6VhOv180",
    opacity: 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "M106.05492,81.40972L119.41584,63.8187l.7017,1.58256-10.60792,14.00737-3.4547,2.00109Z",
    fill: "url(#e58Ebp6VhOv181-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.23183,78.9903l10.04626-13.22693.22167.49994-9.25771,12.14184-1.01022.58515Z",
    fill: "url(#e58Ebp6VhOv182-fill)"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "e58Ebp6VhOv183",
    transform: "translate(0 0.000001)",
    opacity: 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.50569,76.67321l8.24181-10.85119.70223,1.58375-5.51347,7.28034-3.43057,1.9871Z",
    fill: "url(#e58Ebp6VhOv184-fill)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.6826,74.25379l4.92716-6.4871.22098.49838-4.10587,5.38501-1.04227.60371Z",
    fill: "url(#e58Ebp6VhOv185-fill)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamionLoader);
export default __webpack_public_path__ + "static/media/camion-loader.9ab2d463387871e8629029f641c7fa94.svg";
export { ForwardRef as ReactComponent };